import React from 'react';
import DatePicker from './DatePicker';
import useDatePicker from './useDatePicker';
import { isWeb } from 'src/utils/platform';
const DatePickerHelperView = ({}) => {
    const [state] = useDatePicker();
    return isWeb ? React.createElement(DatePicker, { ...state }) : null;
};
export default DatePickerHelperView;
